import React, { useContext, useEffect, useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Modal,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomButton from "../../shared/custom-button/custom-button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import {
  createSubjectService,
  deleteSubjectService,
  getAllSubjectsByGroupId,
  getAllUserSubjectService,
  updateSubjectService,
} from "../../services/subject-service";
import { useSelector } from "react-redux";
import WelcomeCard from "../../componet/welcome-card";
import SubjectModal from "../../componet/subject-modal";
import { RootState } from "../../redux/store/store";
import { SnackbarContext } from "../../config/hooks/use-toast";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChalkboardTeacher, faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import DashboardLayout from "../../shared/layout/DashboardLayout";
import { motion, AnimatePresence } from "framer-motion";
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';


interface SubjectType {
  id: number;
  backgroundImageUrl: string;
  level: string;
  teacherId: string;
  speciality: string;
  groupId?: number;
}

const Subject: React.FC = () => {
  const snackbarContext = useContext(SnackbarContext);
  const role = useSelector(
    (state: RootState) => state?.user?.userData?.role.name,
  );
  const { id } = useParams();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [subjects, setSubjects] = useState<any[]>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [currentItem, setCurrentItem] = useState<any | null>(null);

  const unwrap = (res: any) => res?.data?.data ?? res?.data ?? res;

  const dedupeSubjects = (list: any[]) => {
    const map = new Map<string, any>();
    list?.forEach((item) => {
      const speciality = item?.speciality ?? "";
      const teacherKey = item?.teacherId ?? item?.superTeacherId ?? item?.superTeacherFullName ?? "";
      const key = `${speciality}::${teacherKey}`.toLowerCase();
      if (!map.has(key)) {
        map.set(key, item);
      }
    });
    return Array.from(map.values());
  };


  useEffect(() => {
    if (id) {
      getAllSubjectsByGroupId(Number(id))
        .then((res) => {
          const payload = unwrap(res);
          const unique = dedupeSubjects(payload);
          setSubjects(unique);
        })
        .catch((error) => {
          console.error("Failed to fetch subjects:", error);
        });
    } else {
      getAllUserSubjectService()
        .then((res) => {
          const payload = unwrap(res);
          const unique = dedupeSubjects(payload);
          setSubjects(unique);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [id]);

  const handleOpenModal = (profile: SubjectType | null) => {
    if (profile) {
      setIsEdit(true);
      setModalData(profile);
    } else {
      setIsEdit(false);
      setModalData(null);
    }
    setCurrentItem(profile);
    setModalOpen(true);
    handleCloseMenu();
  };

  const handleCloseModal = () => {
    setCurrentItem(null);
    setIsEdit(false);
    setModalOpen(false);
    handleCloseMenu();
  };

  const handleSave = (formData: any) => {
    const fetchSubjects = () =>
      id ? getAllSubjectsByGroupId(Number(id)) : getAllUserSubjectService();

    if (isEdit && currentItem) {
      updateSubjectService(currentItem.id, formData)
        .then(() => {
          fetchSubjects()
            .then((res) => {
              const payload = unwrap(res);
              setSubjects(dedupeSubjects(payload));
              if (snackbarContext) {
                snackbarContext.showMessage(
                  "Succes",
                  "MatiAcre Modifier avec succAce",
                  "success",
                );
              }
              window.location.reload();
              setModalOpen(false);
            })
            .catch((error) => {
              console.error("Failed to fetch subjects:", error);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      createSubjectService(formData)
        .then(() => {
          fetchSubjects()
            .then((res) => {
              const payload = unwrap(res);
              setSubjects(dedupeSubjects(payload));
              window.location.reload();
              if (snackbarContext) {
                snackbarContext.showMessage(
                  "Succes",
                  "MatiAcre Ajouter avec succAce",
                  "success",
                );
              }
              setModalOpen(false);
            })
            .catch((error) => {
              console.error("Failed to fetch subjects:", error);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const handleClickMenu = (
    event: React.MouseEvent<HTMLElement>,
    item: SubjectType,
  ) => {
    setAnchorEl(event.currentTarget);
    setCurrentItem(item);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClickAlert = () => {
    setOpenAlert(true);
    handleCloseMenu();
  };

  const handleSubjectClick = (item: any) => {
    if (item?.isClosed) {
      if (snackbarContext) {
        snackbarContext.showMessage(
          "Accès verrouillé",
          "Votre abonnement est expiré. Souscrivez pour réactiver cette matière.",
          "info",
        );
      }
      navigate("/dashboard/offer-student");
      return;
    }
    navigate(`/subject-details?id=${item.id}`);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleDelete = () => {
    if (currentItem) {
      deleteSubjectService(currentItem.id)
        .then(() => {
          getAllSubjectsByGroupId(Number(id))
            .then((res) => {
              setSubjects(res.data);
              if (snackbarContext) {
                snackbarContext.showMessage(
                  "Succes",
                  "Matière Supprimer avec succée",
                  "success",
                );
              }
            })
            .catch((error) => {
              console.error("Failed to fetch subjects:", error);
            });
          setOpenAlert(false);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };



  return (
    <DashboardLayout>
      <div className="flex flex-col items-center px-4 pb-20 md:px-12 space-y-6">
        <div className="w-full">
          <WelcomeCard />
        </div>
             
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full my-10 px-4">
          {subjects.map((item) => (
            <div
              key={item.id}
              onClick={() => handleSubjectClick(item)}
              className={`group relative overflow-hidden bg-white rounded-[2.5rem] border border-gray-100 shadow-[0_20px_50px_rgba(0,0,0,0.02)] transition-all duration-500 hover:shadow-[0_30px_70px_rgba(0,0,0,0.08)] hover:-translate-y-2 cursor-pointer ${item.isClosed ? "opacity-90" : ""}`}
            >
              {/* Cover Image with Gradient Overlay */}
              <div className="relative h-56 overflow-hidden">
                <div
                  className="w-full h-full transition-all duration-700 bg-center bg-cover transform group-hover:scale-110"
                  style={{ backgroundImage: `url("${item.backgroundImageUrl}")` }}
                ></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute top-5 left-5 z-20">
                  <span className="px-4 py-2 bg-[#09745f] shadow-xl shadow-black/20 rounded-xl text-[10px] font-black text-white border border-white/10 uppercase tracking-[0.2em]">
                    {item.level}
                  </span>
                </div>
                {item.isClosed && (
                  <div className="absolute inset-0 flex items-center justify-center bg-title/40 backdrop-blur-[2px]">
                    <div className="px-6 py-3 bg-red-500 text-white text-xs font-black rounded-full shadow-2xl border-2 border-white/20 uppercase tracking-widest animate-pulse">Souscription Expire</div>
                  </div>
                )}
                
                {/* Menu Button */}
                {(role === "ROLE_ADMIN" || role === "ROLE_SUPER_TEACHER") && (
                  <div className="absolute top-4 right-4 z-20">
                    <IconButton 
                      onClick={(event) => {
                        event.stopPropagation();
                        handleClickMenu(event, item);
                      }} 
                      className="!bg-white/90 !backdrop-blur-sm !p-2 !rounded-xl shadow-lg hover:!bg-white"
                    >
                      <MoreVertIcon className="text-title" />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl) && currentItem === item}
                      onClose={handleCloseMenu}
                      PaperProps={{
                        sx: { borderRadius: '16px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)', minWidth: '150px', p: 1 }
                      }}
                    >
                      <MenuItem onClick={(e) => { e.stopPropagation(); handleOpenModal(item); handleCloseMenu(); }} className="!rounded-xl !py-2 !font-bold !text-sm">Modifier</MenuItem>
                      <MenuItem onClick={(e) => { e.stopPropagation(); handleClickAlert(); }} className="!rounded-xl !py-2 !font-bold !text-sm !text-red-500">Supprimer</MenuItem>
                    </Menu>
                  </div>
                )}

                <div className="absolute bottom-5 left-5 flex items-center gap-3 p-2 rounded-2xl bg-black/30 backdrop-blur-md border border-white/10">
                  <div className="w-10 h-10 rounded-xl bg-primary border-2 border-white/30 flex items-center justify-center shadow-lg overflow-hidden transition-transform duration-300 group-hover:rotate-6">
                    <FontAwesomeIcon icon={faChalkboardTeacher} className="text-white text-sm" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[10px] font-bold text-white/70 uppercase leading-none">Professeur</span>
                    <span className="text-sm font-black text-white leading-tight truncate max-w-[150px]">{item.superTeacherFullName}</span>
                  </div>
                </div>
              </div>

              {/* Content Section */}
              <div className="p-8">
                <h3 className="text-xl font-black text-title mb-4 leading-tight min-h-[3rem] line-clamp-2 group-hover:text-primary transition-colors duration-300">
                  {item.speciality}
                </h3>
                
                <div className="flex items-center justify-between pt-4 border-t border-gray-50">
                  <div className="flex items-center gap-1.5 text-text/60 font-bold text-xs uppercase tracking-wider">
                    <div className="w-1.5 h-1.5 bg-primary rounded-full"></div>
                    <span>Leçons & Ressources</span>
                  </div>
                  <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center text-gray-400 group-hover:bg-primary group-hover:text-white transition-all duration-300">
                    <FontAwesomeIcon icon={faAnglesRight} className="text-[10px]" />
                  </div>
                </div>
              </div>

              {/* Action Overlay */}
              <div className={`mt-2 ${item.isClosed ? "px-8 pb-8" : "px-8 pb-8 transform translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300"}`}>
                <div className={`w-full py-4 rounded-2xl font-black text-sm uppercase tracking-widest text-center shadow-xl transition-all duration-300 ${item.isClosed ? "bg-gray-100 text-text/40 border border-gray-200" : "bg-primary text-white shadow-primary/20 hover:shadow-primary/30"}`}>
                  {item.isClosed ? "Souscrire" : "Consulter Détails"}
                </div>
              </div>
            </div>
          ))}
          {(role === "ROLE_ADMIN" || role === "ROLE_SUPER_TEACHER") && (
            <div
              onClick={() => handleOpenModal(null)}
              className="flex flex-col items-center justify-center p-12 border-2 border-dashed border-gray-200 rounded-[2.5rem] cursor-pointer bg-gray-50/50 hover:bg-white hover:border-primary/50 hover:shadow-2xl transition-all duration-300 group aspect-[3.5/4]"
            >
              <div className="w-16 h-16 bg-white shadow-md rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 group-hover:bg-primary group-hover:text-white transition-all duration-300">
                <AddIcon fontSize="large" />
              </div>
              <p className="text-title font-black uppercase tracking-widest text-xs">Ajouter une matière</p>
            </div>
          )}
        </div>
        
        <div className="h-10"></div>
       
        <SubjectModal
          open={modalOpen}
          onClose={handleCloseModal}
          initialData={modalData ?? undefined}
          defaultGroupId={id ? Number(id) : undefined}
          isEdit={isEdit}
          modalTitle={isEdit ? "Modifier Matiere" : "Ajouter Matiere"}
          buttonText={isEdit ? "Mettre à jour" : "Ajouter Matiere"}
          onButtonClick={handleSave}
        />
        <AnimatePresence>
          {openAlert && (
            <Modal
              open={openAlert}
              onClose={handleCloseAlert}
              className="flex items-center justify-center p-4 backdrop-blur-xl bg-title/40"
              closeAfterTransition
            >
              <motion.div 
                className="w-full max-w-[450px] bg-white rounded-[3rem] p-10 shadow-3xl text-center outline-none border border-white/20"
                initial={{ scale: 0.9, opacity: 0, y: 20 }}
                animate={{ scale: 1, opacity: 1, y: 0 }}
                exit={{ scale: 0.9, opacity: 0, y: 20 }}
                transition={{ type: "spring", damping: 25, stiffness: 300 }}
              >
                <div className="w-24 h-24 rounded-[2.5rem] bg-rose-50 text-rose-500 flex items-center justify-center text-4xl mx-auto mb-8 border border-rose-100 shadow-sm relative">
                  <div className="absolute inset-0 bg-rose-400/20 rounded-[2.5rem] animate-ping opacity-50"></div>
                  <FontAwesomeIcon icon={faTrashCan} className="relative z-10" />
                </div>
                
                <h3 className="text-2xl font-black text-title uppercase tracking-tight mb-4">
                  Confirmer la <span className="text-rose-500">Suppression</span>
                </h3>
                
                <p className="text-sm font-medium text-text/60 leading-relaxed mb-10 px-4">
                  Êtes-vous sûr de vouloir supprimer cette matière <span className="text-[#05322B] font-black">{currentItem?.speciality}</span> ? Cette action est irréversible.
                </p>

                <div className="flex gap-4">
                  <button
                    className="flex-1 h-16 bg-slate-50 text-text/40 font-black text-[11px] uppercase tracking-widest rounded-2xl hover:bg-slate-100 transition-all duration-300 outline-none"
                    onClick={handleCloseAlert}
                  >
                    Annuler
                  </button>
                  <button
                    className="flex-1 h-16 bg-rose-500 text-white font-black text-[11px] uppercase tracking-widest rounded-2xl shadow-xl shadow-rose-500/20 hover:bg-rose-600 hover:-translate-y-1 transition-all duration-300 outline-none"
                    onClick={handleDelete}
                  >
                    Supprimer
                  </button>
                </div>
              </motion.div>
            </Modal>
          )}
        </AnimatePresence>
      </div>
    </DashboardLayout>
  );
};

export default Subject;
